import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  ReferenceField,
  Filter,
  TextInput,
  BooleanInput,
  ReferenceInput,
  AutocompleteInput
} from 'react-admin';
import { ApiResource } from '../../lib/api';

const FeatureFlagsFilter: React.FC = (props: any) => {
  return (
    <Filter {...props}>
      <TextInput source='id'/>
      <TextInput source='internalName'/>
      <TextInput source='displayName'/>
    </Filter>
  );
};

const FeatureFlagsList: React.FC = (props: any) => {
  return (
    <List
      filters={<FeatureFlagsFilter/>}
      {...props}
    >
      <Datagrid
        rowClick='edit'
      >
        <TextField source='id'/>
        <TextField source='internalName'/>
        <TextField source='displayName'/>
      </Datagrid>
    </List>
  );
};

export default FeatureFlagsList;